import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./Hub.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'
import { MovingTagContainer } from '../Utils/Helpers'


const TagsPage = ({ toggledMenu, indEvent, setIsLoading, isLoading, setShowTags, setIndEvent }) => {
	const [hovered, setHovered] = useState(null);
	const [formData, setFormData] = useState({});
	const [editMade, setEditMade] = useState(false)


	useEffect(() => {
		const handleLoad = async () => {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				setIsLoading(true)
				const retrieve = await axios.get(`/api/hub/get-guestii-tags/${userId}/${toggledMenu._id}/${indEvent._id}`);
				setFormData({tags: retrieve.data.tags.map(t => ({ label: t.tag, value: t.tag }))})
				setIsLoading(false)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		handleLoad()
	}, [])

	const handleClose = () => {
		setFormData(null)
		setEditMade(false)
		setShowTags(false)
	}

	const handleForm = async (control, label, input) => {
		switch (control) {
			case 'set':
				setFormData({ tags: input.map(t => ({ value: t.value, label: t.value })) })
				setEditMade(true)
				break;
			case 'submit':
				const userId = localStorage.getItem("_id")
				if (!userId) {
					locationStorage.removeItem("_id")
					locationStorage.removeItem("expiry")
					window.location = "/connect"
				}

				await axios.post(`/api/hub/set-guestii-tags/${userId}`, {
					tags: formData.tags.map(t => t.value),
					guestii: toggledMenu._id,
					event: indEvent._id
				});

				setIndEvent(prev => {
				  	const newTags = formData.tags.map(t => ({
				    	for: toggledMenu._id,
				    	source: userId,
				    	tag: t.value,
				    	event: prev._id
				  	}));

				  	const updatedGuestiis = prev.guestiis.map(g => g._id.toString() === toggledMenu._id.toString()
				      	? { ...g, tags: newTags }
				      	: g
				  	);

				  	return { ...prev, guestiis: updatedGuestiis };
				});

				handleClose()
				break;
		}
	}

	return (
		<div className={`${styles.popup_container_ind} ${isLoading && styles.popup_setheight}`}>
			{!isLoading
				?
					<div className={styles.ratings_layout}>
						<button className={styles.ind_close_ind} onClick={handleClose}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

						<div className={styles.new_banner}>
							<div className={styles.new_title}>
								<p className={styles.bold}>Set Guestii Tags</p>
								<p className={styles.s1}>Select tags or create your own</p>
							</div>

							<div className={styles.banner_progress}>
								<div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
									<i className={`fa-solid fa-star ${styles.m1}`}></i>
								</div>
							</div>
						</div>

						<div className={styles.ratings_form_container}>
							<div className={styles.tags_warning}>
								<p className={styles.s1}>Tags are event specific. Guestiis page shows all tags.</p>
							</div>

				            <div className={styles.tagContainerOuter}>
								<MovingTagContainer
									label={"Tags"}
									icon={"fa-solid fa-tag"}
									handleForm={handleForm}
									formData={formData}
									showLabel={false}
									bottom={false}
								/>
							</div>
						</div>

						<div className={styles.control_container}>
							<button disabled={!editMade} onClick={() => handleForm('submit')} className={`${styles.control_btn} ${styles.next_btn}`} style={!editMade ? { visibility: "hidden" } : { visibility: 'visible' }}>
								<i className={`fa-solid fa-check ${styles.m1}`}></i>
							</button>
						</div>
					</div>
				:
			        <div className={styles.loading_layout}>
			            <img src={guestii_gif}/>
			        </div>
			}
		</div>
	)
}


const Tags = ({ indEvent, setShowTags, toggledMenu, setIndEvent }) => {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<TagsPage {... { toggledMenu, indEvent, setIsLoading, isLoading, setShowTags, setIndEvent } }/>
	);
};

export default Tags;